import script from "./LandingPageMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./LandingPageMobile.vue?vue&type=script&setup=true&lang=js"

import "./LandingPageMobile.vue?vue&type=style&index=0&id=354c3779&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-354c3779"]])

export default __exports__